module.exports = __webpack_public_path__ + "05_glasses_red.bc3eb76e.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/kanai/female/layer4/05_glasses_red.png
// module id = PARz
// module chunks = 0